module.exports = __webpack_public_path__ + "img/plug-right.43dd25d9.png";